module.exports = __webpack_public_path__ + "static/img/93039G_1_R_20201130_LC.3bff6f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/93039G_1_R_20201130_LC.png
// module id = 7rEx
// module chunks = 0